export const environment = {
  production: true,
  hmr: false,
  serverUrl: 'https://api.hindu.social/api/v1/',
  serverUrl2: 'http://localhost:8081/api/v1/',
  socketUrl: 'https://api.hindu.social/',
  socketUrl2: 'http://localhost:8081/',
  imgUrl: 'root/storage/uploads',

};
